import { render, staticRenderFns } from "./AnalyticsRevenueByArea.vue?vue&type=template&id=634f2ce5"
import script from "./AnalyticsRevenueByArea.vue?vue&type=script&lang=js"
export * from "./AnalyticsRevenueByArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports